import React from 'react';
import { Helmet } from 'react-helmet-async';

const FAQSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Where are the upcycling workshops located?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our upcycling and sewing workshops are located in Warsaw, Poland. We offer both in-person workshops at our studio and some online options for international participants."
                }
            },
            {
                "@type": "Question",
                "name": "Gdzie odbywają się warsztaty upcyklingu?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nasze warsztaty upcyklingu i szycia odbywają się w Warszawie. Oferujemy zarówno warsztaty stacjonarne w naszym studiu, jak i niektóre opcje online dla uczestników międzynarodowych."
                }
            },
            {
                "@type": "Question",
                "name": "Do I need sewing experience to join a workshop?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No! We offer workshops for all skill levels, from complete beginners to advanced sewers. Our beginner-friendly workshops teach you everything you need to know to start your upcycling journey."
                }
            },
            {
                "@type": "Question",
                "name": "What materials are provided in the workshops?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "All necessary materials and tools are included in the workshop price. This includes fabric, thread, sewing machines, and any additional supplies needed for your project. You're welcome to bring your own materials if you prefer."
                }
            },
            {
                "@type": "Question",
                "name": "How do I book a workshop?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can book a workshop directly through our website. Select your preferred workshop, choose an available date, and complete the booking with secure online payment via Stripe."
                }
            },
            {
                "@type": "Question",
                "name": "Are the handmade pieces one-of-a-kind?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! Every piece in our shop is unique and handmade. We create sustainable fashion through upcycling, which means each item is crafted from reclaimed materials and no two pieces are exactly alike."
                }
            },
            {
                "@type": "Question",
                "name": "What is upcycling?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Upcycling is the process of transforming old or discarded materials into new, higher-quality products. In fashion, it means taking existing garments or textiles and creatively redesigning them into unique, wearable pieces, reducing waste and promoting sustainability."
                }
            },
            {
                "@type": "Question",
                "name": "Do you ship internationally?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we ship our handmade upcycled fashion pieces internationally. Shipping costs and delivery times vary by location. All details are provided during checkout."
                }
            }
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export default FAQSchema;
